import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { ScApiService, EventService } from '@sc-ui';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocalizationService } from 'src/services/localization.service';
import { texts } from './project-applications.texts';

@Component({
  standalone: false,
  selector: 'app-project-applications',
  templateUrl: './project-applications.html',
  styleUrl: './project-applications.scss',
})
export class ProjectApplications implements OnChanges, OnDestroy {

  texts = texts;

  @Input()
  project: any;

  candidates: any = [];

  groups: any = [];

  isLoading = true;

  private onDestroy = new Subject();

  constructor(private api: ScApiService, private events: EventService, public loc: LocalizationService) { }

  ngOnDestroy() {

    this.onDestroy.next();

  }
  ngOnChanges() {

    this.onDestroy.next();

    if (!this.project) return;

    this.candidates = []

    this.events
      .channel(`projects/${this.project.Id}/assignments`)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d: any) => {

        console.log(d);

        var candidate = this.candidates.find(c => c.Id == d.Payload?.CandidateId);
        console.log(this.candidates);

        if (candidate) {
          candidate.Assignment.AcceptanceStatus = d.Payload.AcceptanceStatus;
          candidate.Assignment.IsHired = d.Payload.IsHired;
        }
      });
    

    this.api.get(`projects/${this.project.Id}/candidates`).subscribe((d: any) => {

      this.isLoading = false;
      this.candidates = d;

      var assignments: any = d;
      if (!assignments?.length) return;

      var groups = [];

      var interested = assignments.filter(a => a.Assignment.ListingStatus == 'Listed' && a.Assignment.AcceptanceStatus == 'None' && a.Assignment.InterestedStatus != 'Revoked');
      if (interested.length > 0) {
        groups.push({
          name: texts.groups.shortlisted,
          items: interested
        });
      }

      var shortlistedNonCommittal = assignments.filter(a => a.Assignment.ListingStatus == 'ListedNonCommittal' && a.Assignment.AcceptanceStatus == 'None' && a.Assignment.InterestedStatus != 'Revoked');
      if (shortlistedNonCommittal.length > 0) {
        groups.push({
          name: texts.groups.shortlistedNonCommittal,
          items: shortlistedNonCommittal
        });
      }

      var accepted = assignments.filter(a => a.Assignment.AcceptanceStatus == 'Accepted' && !a.Assignment.IsHired && a.Assignment.InterestedStatus != 'Revoked');
      if (accepted.length > 0) {
        groups.push({
          name: texts.groups.inSelection,
          items: accepted
        });
      }

      var hired = assignments.filter(a => a.Assignment.IsHired);
      if (hired.length > 0) {
        groups.push({
          name: texts.groups.hired,
          items: hired
        });
      }

      var rejected = assignments.filter(a => (a.Assignment.AcceptanceStatus == 'Rejected' || a.Assignment.InterestedStatus == 'Revoked') && !a.Assignment.IsHired);
      if (rejected.length > 0) {
        groups.push({
          name: texts.groups.notHired,
          items: rejected
        });
      }

      this.groups = groups;

    });

  }
}
